 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"activity-gallery-activity-gallery-module":"activity-gallery-activity-gallery-module","activity-types-activity-types-module":"activity-types-activity-types-module","agenda-agenda-module":"agenda-agenda-module","benefits-details-details-module":"benefits-details-details-module","catalogues-benefits-catalogues-benefits-module":"catalogues-benefits-catalogues-benefits-module","common":"common","benefit-companies-benefit-companies-module":"benefit-companies-benefit-companies-module","benefit-company-types-benefit-company-types-module":"benefit-company-types-benefit-company-types-module","benefits-benefits-module":"benefits-benefits-module","benefits-index-index-module":"benefits-index-index-module","companies-companies-module":"companies-companies-module","contacts-contacts-module":"contacts-contacts-module","create-benefit-company-create-benefit-company-module":"create-benefit-company-create-benefit-company-module","create-benefit-company-type-create-benefit-company-type-module":"create-benefit-company-type-create-benefit-company-type-module","create-benefit-create-benefit-module":"create-benefit-create-benefit-module","create-contact-create-contact-module":"create-contact-create-contact-module","create-event-create-event-module":"create-event-create-event-module","create-institution-create-institution-module":"create-institution-create-institution-module","create-related-report-create-related-report-module":"create-related-report-create-related-report-module","create-team-create-team-module":"create-team-create-team-module","duplicates-review-duplicates-review-module":"duplicates-review-duplicates-review-module","events-events-module":"events-events-module","projects-projects-module":"projects-projects-module","team-invitations-team-invitations-module":"team-invitations-team-invitations-module","user-areas-user-areas-module":"user-areas-user-areas-module","create-activity-type-create-activity-type-module":"create-activity-type-create-activity-type-module","create-affiliate-create-affiliate-module":"create-affiliate-create-affiliate-module","create-feedback-create-feedback-module":"create-feedback-create-feedback-module","create-profile-create-profile-module":"create-profile-create-profile-module","create-project-create-project-module":"create-project-create-project-module","default~activities-requests-activities-requests-module~activity-details-activity-details-module~crea~fb35dfc3":"default~activities-requests-activities-requests-module~activity-details-activity-details-module~crea~fb35dfc3","activity-details-activity-details-module":"activity-details-activity-details-module","default~activities-requests-activities-requests-module~create-report-create-report-module~edit-profi~fc7c5a13":"default~activities-requests-activities-requests-module~create-report-create-report-module~edit-profi~fc7c5a13","edit-profile-edit-profile-module":"edit-profile-edit-profile-module","edit-report-edit-report-module":"edit-report-edit-report-module","edit-team-edit-team-module":"edit-team-edit-team-module","default~activities-requests-activities-requests-module~create-report-create-report-module~index-inde~c136c385":"default~activities-requests-activities-requests-module~create-report-create-report-module~index-inde~c136c385","activities-requests-activities-requests-module":"activities-requests-activities-requests-module","create-report-create-report-module":"create-report-create-report-module","index-index-module":"index-index-module","reports-reports-module":"reports-reports-module","staff-report-staff-report-module":"staff-report-staff-report-module","register-register-module":"register-register-module","edit-contact-edit-contact-module":"edit-contact-edit-contact-module","edit-password-edit-password-module":"edit-password-edit-password-module","getting-started-getting-started-module":"getting-started-getting-started-module","login-login-module":"login-login-module","my-digital-card-my-digital-card-module":"my-digital-card-my-digital-card-module","password-request-password-request-module":"password-request-password-request-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","settings-catalogues-settings-catalogues-module":"settings-catalogues-settings-catalogues-module","settings-settings-module":"settings-settings-module","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","show-team-invitation-show-team-invitation-module":"show-team-invitation-show-team-invitation-module","teams-teams-module":"teams-teams-module","users-users-module":"users-users-module","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-73f15161-js":"input-shims-73f15161-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-bdecfebf-js":"status-tap-bdecfebf-js","swipe-back-ee838cf8-js":"swipe-back-ee838cf8-js","tap-click-cc1ae2b2-js":"tap-click-cc1ae2b2-js"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
